<template>
    <figure class="image is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only" style="margin-top: 30px;">
        <img src="https://assets.webbank.com/newsroom/pr51_hero.png" alt="Libertas Funding Secures $75 Million">
    </figure>
    <figure class="image is-hidden-widescreen">
        <img src="https://assets.webbank.com/newsroom/pr51_small.png" alt="Libertas Funding Secures $75 Million">
    </figure>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">

                    <router-link class="button is-primary is-small is-pulled-right" to="/newsroom">
                        <span class="icon"><i class="fas fa-arrow-left"></i></span>
                        <span>Back to Newsroom</span>
                    </router-link>
                    <p class="press-release">Press Release</p>
                    <br>
                    <div class="content">
                        <h2 class="news-page-title">Libertas Funding Secures Inaugural $75 Million Investment Grade Corporate Note</h2>
                        <br>
                        <p><em><small>April 1, 2025</small></em></p>
                        <br>
                        <p><strong>GREENWICH, Conn., April 1, 2025 (Newswire.com)</strong> - Libertas Funding (Libertas), a growth capital provider specializing in sophisticated financial solutions for small to medium-sized businesses, today announced the successful closing of $75 million investment-grade corporate note financing. The proceeds from this transaction will be used for liquidity and working capital purposes.</p>
                        <p>The company offers a broad array of tailored short-term, revenue-based financing and term loan* options. Since its inception in September 2016, Libertas Funding has provided access to over $4 billion in funding to thousands of businesses and is recognized as one of the largest and fastest-growing providers of growth capital in the country.</p>
                        <p>"We are thrilled to announce the closing of our inaugural corporate note raise," said <strong>Gary Katcher, Libertas Executive Chairman</strong> and founder. "We greatly appreciate the support from our institutional investors and the confidence they have in our platform."</p>
                        <p><strong>Randy Saluck, Libertas Chief Executive Officer</strong>, added, "This note financing provides us with a strong capital cushion and increased operational flexibility as we continue to fortify our balance sheet."</p>
                        <p><strong>Brean Capital, LLC</strong> served as the Company's Exclusive Financial Advisor and Sole Placement Agent in connection with the transaction.</p>
                        <br>
                        <p><strong>About Libertas Funding, LLC</strong></p>
                        <p>Established in 2016, Libertas Funding is a leading growth capital provider that has delivered over $4 billion in funding solutions to small and medium-sized businesses. The company combines sophisticated technology with personalized service to provide businesses with rapid, strategic funding solutions that enable sustainable growth. Through its institutional-grade execution and relationship-based approach, Libertas has established itself as a trusted, long-term financial partner committed to client success. The company's advanced technology and expert industry knowledge ensure businesses receive swift access to the capital needed to thrive. For more information about Libertas' growth capital solutions, visit <a @click="clickOutWarning('https://libertasfunding.com');">libertasfunding.com</a>.</p>
                        <br>
                        <p><small><em>* Business term loans issued by WebBank.</em></small></p>
                        <br>
                    </div>

                    <div class=" modal" :class="{ 'is-active': clickout_modal }">
                        <div class="modal-background"></div>
                        <div class="modal-content">
                            <div class="box">
                                <h2 class="box-title">You are leaving our site!</h2>
                                <br>
                                <p>You will be linking to another website not owned or operated by WebBank.</p>
                                <br>
                                <p>WebBank is not responsible for the availability or content of this website
                                    and does not represent either the linked website or you, should you enter into a
                                    transaction.</p>
                                <br>
                                <p>The inclusion of any hyperlink does not imply any endorsement, investigation,
                                    verification or monitoring by WebBank of any information in any hyperlinked
                                    site. We encourage you to review their privacy and security policies which may differ
                                    from WebBank.</p>
                                <br>
                                <p>If you click &quot;Proceed&quot;, the link will open in a new window.</p>
                                <br>
                                <br>
                                <div class="field is-grouped">
                                    <div class="control">
                                        <button class="button is-link" @click="doClickout">Proceed</button>
                                    </div>
                                    <div class="control">
                                        <button class="button is-link is-light"
                                            @click="clickout_modal = false">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

    created() {
        document.title = "Libertas Funding Secures $75 Million";
    },

    data: function () {
        return {
            clickout_modal: false,
            clickout_url: null,
        }
    },

    methods: {
        clickOutWarning: function (url) {
            this.clickout_url = url;
            this.clickout_modal = true;
        },


        doClickout: function () {
            this.clickout_modal = false;
            window.open(this.clickout_url, "_blank");
        },
    }
}
</script>
